const DEFAULT_MAX_BASE64_SIZE = 666_000; // ~500KB decoded

/**
 * Ensure a canvas image is within the base64 size limit.
 * If oversized, progressively halve pixel dimensions (sqrt(2) per axis)
 * until the base64 output is under maxBase64Size.
 */
export async function ensureImageSizeAsync(
  canvas: HTMLCanvasElement,
  maxBase64Size = DEFAULT_MAX_BASE64_SIZE,
): Promise<{ dataUrl: string; base64: string }> {
  let dataUrl = canvas.toDataURL('image/jpeg', 0.85);
  let base64 = dataUrl.split(',')[1];

  if (base64.length <= maxBase64Size) {
    return { dataUrl, base64 };
  }

  // image is oversized — progressively resize
  console.log('Image oversized', {
    originalBase64Length: base64.length,
    originalWidth: canvas.width,
    originalHeight: canvas.height,
  });

  let w = canvas.width;
  let h = canvas.height;
  const factor = 1 / Math.SQRT2; // scale by sqrt(2) each step

  for (let attempt = 0; attempt < 10 && base64.length > maxBase64Size; attempt++) {
    w = Math.round(w * factor);
    h = Math.round(h * factor);

    const smaller = document.createElement('canvas');
    smaller.width = w;
    smaller.height = h;
    smaller.getContext('2d').drawImage(canvas, 0, 0, w, h);

    dataUrl = smaller.toDataURL('image/jpeg', 0.85);
    base64 = dataUrl.split(',')[1];
    canvas = smaller;
  }

  console.log(`Image resized to ${w}x${h} (base64 length: ${base64.length})`);
  return { dataUrl, base64 };
}
